import type { ActionDispatch } from "react";
import { useCallback } from "react";
import type { FieldConfiguration } from "../../../../../../../../api/types/fieldConfigurationTypes.ts";
import type { ConditionField, ReportField, SortField } from "../../../../../../../../api/types/svTypes.ts";
import type { RunStateAction } from "../../storage/runState.ts";

const useViewReportHandlers = (dispatchRunState: ActionDispatch<[action: RunStateAction]>) => {
  const handleFieldUpdate = useCallback(
    (field: ReportField, change: Partial<FieldConfiguration>) => {
      dispatchRunState({ type: "UpdateFieldConfig", payload: { field, changes: change } });
    },
    [dispatchRunState]
  );

  const handleConditionUpdate = useCallback(
    (field: ConditionField, changes: Partial<ConditionField>) => {
      dispatchRunState({ type: "UpdateCondition", payload: { field, changes } });
    },
    [dispatchRunState]
  );

  const handleRefreshGrid = useCallback(() => {
    dispatchRunState({ type: "RefreshGrid" });
  }, [dispatchRunState]);

  const handleSortingUpdate = useCallback(
    (newSorting: SortField[]) => {
      dispatchRunState({ type: "UpdateSorting", payload: { newSorting } });
    },
    [dispatchRunState]
  );

  return {
    handleFieldUpdate,
    handleConditionUpdate,
    handleRefreshGrid,
    handleSortingUpdate,
  };
};

export default useViewReportHandlers;
